// areas
export const GARDEN_AREAS = [
  "Техніка",
  "Інвентар та матеріали",
  "Полив",
  "Меблі та зона відпочинку",
  "Басейни та гриль",
  "Ландшафт і декор",
  "Рослини і догляд",
  "Інше",
];

// sections by area
const SECTIONS_BY_AREA = {
  "Техніка": [
    "Газонокосарки / Аератори",
    "Тримери / Мотокоси",
    "Бензопили / Ланцюгові",
    "Кущорізи",
    "Подрібнювачі",
    "Снігоприбирачі",
    "Аксесуари / Комплектуючі (техніка)",
  ],

  "Інвентар та матеріали": [
    "Оприскувачі",
    "Ручний інструмент",
    "Агроволокно / Плівка",
    "Приладдя (граблі/лопати/тощо)",
  ],

  "Полив": [
    "Шланги та з’єднання",
    "Насосне обладнання",
    "Зрошувачі / Насадки",
    "Крапельний полив (набори/комплектуючі)",
  ],

  "Меблі та зона відпочинку": [
    "Комплекти меблів",
    "Крісла / Столи / Лавки",
    "Шезлонги / Лежаки",
    "Гойдалки",
    "Гамаки",
    "Павільйони / Намети / Альтанки",
    "Парасолі садові / пляжні",
  ],

  "Басейни та гриль": [
    "Басейни та аксесуари",
    "Гриль / Мангал та аксесуари",
  ],

  "Ландшафт і декор": [
    "Паркани / Огорожі / Сітки / Бордюри",
    "Садовий декор",
  ],

  "Рослини і догляд": [
    "Насіння",
    "Саджанці (дерева/кущі/розсада)",
    "Бульби / Цибулини",
    "Добрива",
    "Ґрунти / Субстрати",
    "Захист рослин (ЗЗР)",
    "Кімнатні рослини",
  ],

  "Інше": ["Інше для саду/подвірʼя"],
};

// subcategories
const SUBCATS_BY_SECTION = {
  "Газонокосарки / Аератори": [],
  "Тримери / Мотокоси": [],
  "Бензопили / Ланцюгові": [],
  "Кущорізи": [],
  "Подрібнювачі": [],
  "Снігоприбирачі": [],
  "Аксесуари / Комплектуючі (техніка)": [],

  "Оприскувачі": [],
  "Ручний інструмент": [],
  "Агроволокно / Плівка": [],
  "Приладдя (граблі/лопати/тощо)": [],

  "Шланги та з’єднання": [],
  "Насосне обладнання": [],
  "Зрошувачі / Насадки": [],
  "Крапельний полив (набори/комплектуючі)": [],

  "Комплекти меблів": [],
  "Крісла / Столи / Лавки": [],
  "Шезлонги / Лежаки": [],
  "Гойдалки": [],
  "Гамаки": [],
  "Павільйони / Намети / Альтанки": [],
  "Парасолі садові / пляжні": [],

  "Басейни та аксесуари": [],
  "Гриль / Мангал та аксесуари": [],

  "Паркани / Огорожі / Сітки / Бордюри": [],
  "Садовий декор": [],

  "Насіння": [],
  "Саджанці (дерева/кущі/розсада)": [],
  "Бульби / Цибулини": [],
  "Добрива": [],
  "Ґрунти / Субстрати": [],
  "Захист рослин (ЗЗР)": [],
  "Кімнатні рослини": [],

  "Інше для саду/подвірʼя": [],
};

// fields
export const gardenFields = (attrs) => {
  const a = attrs || {};
  const area = a.area || "";
  const section = a.section || "";

  const areaOnly = [
    {
      name: "area",
      label: "Сфера *",
      type: "select",
      options: GARDEN_AREAS,
      required: true,
    },
  ];
  if (!area) return areaOnly;

  const sectionOnly = [
    ...areaOnly,
    {
      name: "section",
      label: "Розділ",
      type: "select",
      options: SECTIONS_BY_AREA[area] || [],
      required: false,
    },
  ];
  if (!section) return sectionOnly;

  const subcats = SUBCATS_BY_SECTION[section] || [];
  if (!subcats.length) return sectionOnly;

  return [
    ...sectionOnly,
    {
      name: "subcategory",
      label: "Підкатегорія",
      type: "select",
      options: subcats,
      required: false,
    },
  ];
};
